module.exports = __webpack_public_path__ + "static/media/CheckIconThumbnails.ac6ade17.jpg";